// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { generateId, mobileView } from '../_common/api/utility';
import Cart, { itemTypes } from '../_common/Cart';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import { AddVehicle } from '../_pwa/pages/WashClubs';

const Wrapper = styled.div`
    padding: 0.5em 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    position: relative;

    ${({ mobile, theme }) => mobile && `
        background: ${theme.tertiary}40;
        border-radius: 2rem;
        margin: 1em 0;
        flex-direction: column;
        align-items: center;
    `}
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0 1em;
`
const Row = styled.div`
    display: flex;
    justify-content: center;
`
const SmallText = styled.div`
    font-size: 0.5em;
`
const Price = styled.div`
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 2em;
    font-decoration: italic;
`
const AbsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
`
const InfoBox = styled.div`
    display: flex;
    flex-direction: column;
    transition: all 0.2s;
    font-size:  ${({ mobile }) => mobile ? '0.7em' : '0.5em'};
    overflow: auto;
    padding: 0 2em;
`
const ColorCard = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${({ color }) => color};
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
`
const ImgCard = styled.div`
    background-image: url(${({ image }) => `https://ewash.net/HamiltonCarWash/static/media/slideLogo${image}@2x.png`});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 0.5rem;
    width: 300px;
    height: 300px;

    ${({ mobile }) => mobile && `
        height: calc(50vmin);
        width: calc(50vmin);
    `}
`

const ProductCard = ({ title, price = 0, color, image, details, item, ...props }) => {
    const { state: {
        active_user,
        // mobileView
    } } = useGlobalState();

    return (
        <Wrapper id={props.id} mobile={mobileView}>
            <ImgCard
                image={item.logo.imageIndex}
                mobile={mobileView}
                {...props}
            >
                <ColorCard color={`rgb(${item.logo.red}, ${item.logo.green}, ${item.logo.blue}, ${item.logo.alpha})`}>
                </ColorCard>
            </ImgCard>
            <Col>
                <b>{title}</b>
                <InfoBox mobile={mobileView}>
                    {details.map(e => <div key={generateId()}>{e}</div>)}
                </InfoBox>
            </Col>
            <AbsWrapper>
                {
                    item.productType !== itemTypes.washClub ?
                        <Price><SmallText>$</SmallText>{price.toFixed(2).replace('.00', '')}</Price> :
                        <>
                            {item.signupPrice === price ? <Price style={{ fontSize: '1.5em' }}>Signup: <SmallText>$</SmallText>{item.signupPrice.toFixed(2).replace('.00', '')}</Price> : null}
                            <Price style={{ fontSize: '1.5em' }}>Monthly: <SmallText>$</SmallText>{item.monthlyPrice.toFixed(2).replace('.00', '')}</Price>
                        </>
                }
                {
                    item.productType === itemTypes.washClub ?
                        !active_user.isLoggedIn ?
                            <SmallText>Please Log in to purchase a Wash Club</SmallText> :
                            !active_user.vehicle ?
                                <AddVehicle /> :
                                <>
                                    {Cart.GiftButton(item)}
                                    {Cart.AddButton(item)}
                                </> :
                        <>
                            {Cart.GiftButton(item)}
                            {Cart.AddButton(item)}
                        </>
                }
            </AbsWrapper>
        </Wrapper>
    );
}

export default ProductCard;